export default __webpack_public_path__ + "static/media/bcp.edf7cf63.webp";